export const COOKIE_KID = 'ds-kid'
export const COOKIE_TFF = 'ds-tff-enabled'
export const AUTH_METHOD_KEY = 'AUTH_METHOD'
export enum AuthMethod {
  VIPPS = 'vipps-login',
  REGULAR = 'regular',
  BANKID = 'bankid',
  AGENT = 'agent',
}
